import { POND_STATUS_CYCLE } from 'utils/consts';
import api from './api';

const BASE_URL = '/cycles';

class CycleService {
  constructor() {
    this.httpClient = api;
  }

  async pondsAvailableToPopulate(idCycle) {
    try {
      const pondCyclesByIdCycle = await (await api.get(`${BASE_URL}/cycle-code/${idCycle}`)).data;

      const statusInclude = (pond) => [POND_STATUS_CYCLE.CULTIVANDO, POND_STATUS_CYCLE.PREPARANDO].includes(pond.status);

      const filteredPondCycles = pondCyclesByIdCycle.filter(statusInclude);
      return filteredPondCycles;
    } catch (error) {
      const errorMessage = error.response?.data?.message;
      throw new Error(errorMessage);
    }
  }
}

export default new CycleService();
